import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AssociatedDocumentEditionView } from "./AssociatedDocumentEditionView";
import { AssociatedDocumentEditionViewStore } from "../../store/AssociatedDocumentEditionViewStore";
import { useStore } from "../../../../hooks";

export const AssociatedDocumentEditionViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/associatedDocumentEdition/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AssociatedDocumentEditionViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AssociatedDocumentEditionView
          associatedDocumentEditionViewStore={store}
        />
      </PageLayout>
    </div>
  );
});
